import { lazy } from 'react';

// Every dialog here is lazy-loaded: `ModalProvider` (see App.tsx) runs in `suspense` mode, so `showModal(X, props)`
// call sites need no changes — the dialog's chunk is only fetched the first time it's actually opened.
const FollowUpAddEditDialog = lazy(() => import('./Followups/FollowUpAddEditDialog'));
const FollowUpTaskAddEditDialog = lazy(() => import('./Tasks/FollowUpTaskAddEditDialog'));
const PdfDialog = lazy(() => import('@/shared/ui/components/Dialogs/Documents/PdfDialog'));
const AddActivityDialog = lazy(() => import('./CareActivities/AddActivityDialog'));
const AddFollowupConsultDialog = lazy(() => import('./Followups/AddFollowupConsultDialog'));
const AddToAthenaDialog = lazy(() => import('./EhrIntegration/AddToAthenaDialog'));
const AddUserDialog = lazy(() => import('./AddUserDialog'));
const AssignRelyingPartyAdminDialog = lazy(() => import('./Provider/AssignRelyingPartyAdminDialog'));
const AssignTasksToEncounterDialog = lazy(() => import('./Tasks/AssignTasksToEncounterDialog'));
const CheckCcmEligibilityDialog = lazy(() => import('./RpmCandidates/CheckCcmEligibilityDialog'));
const ConfirmHealthCarePatientAttributesDialog = lazy(() => import('./Patient/ConfirmHealthCarePatientAttributesDialog'));
const CreateCommentDialog = lazy(() => import('./Communication/CreateCommentDialog'));
const CreateRequestDialog = lazy(() => import('./Communication/CreateRequestDialog'));
const EditEncounterDialog = lazy(() => import('./Encounter/EditEncounterDialog'));
const NewEncounterDialog = lazy(() => import('./Encounter/NewEncounterDialog'));
const NewTaskDialog = lazy(() => import('./Tasks/NewTaskDialog'));
const PatientUnenrollDialog = lazy(() => import('./PatientUnenrollDialog'));
const ProfileDialog = lazy(() => import('./ProfileDialog'));
const SaveFilterDialog = lazy(() => import('./Templates/SaveFilterDialog'));
const ScheduleEnrollmentDialog = lazy(() => import('./ScheduleEnrollmentDialog'));
const UpdateActivityDialog = lazy(() => import('./CareActivities/UpdateActivityDialog'));
const UpdateFollowupConsultDialog = lazy(() => import('./Followups/UpdateFollowupConsultDialog'));

export {
  AddActivityDialog,
  AddFollowupConsultDialog,
  AddToAthenaDialog,
  AddUserDialog,
  AssignRelyingPartyAdminDialog,
  AssignTasksToEncounterDialog,
  CheckCcmEligibilityDialog,
  ConfirmHealthCarePatientAttributesDialog,
  CreateCommentDialog,
  CreateRequestDialog,
  EditEncounterDialog,
  FollowUpAddEditDialog,
  FollowUpTaskAddEditDialog,
  NewEncounterDialog,
  NewTaskDialog,
  PatientUnenrollDialog,
  PdfDialog,
  ProfileDialog,
  SaveFilterDialog,
  ScheduleEnrollmentDialog,
  UpdateActivityDialog,
  UpdateFollowupConsultDialog
};
